var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled, { css } from "styled-components";
import BaseBox from './BaseBox';
var GridBox = styled(BaseBox)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: grid;\n  grid-gap: ", ";\n  ", "\n"], ["\n  display: grid;\n  grid-gap: ", ";\n  ", "\n"])), function (_a) {
    var gap = _a.gap;
    return gap ? gap + "px" : "12px";
}, function (_a) {
    var itemWidth = _a.itemWidth;
    return itemWidth && css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      grid-template-columns: repeat(auto-fill, ", "px);\n  "], ["\n      grid-template-columns: repeat(auto-fill, ", "px);\n  "])), itemWidth);
});
export default GridBox;
var templateObject_1, templateObject_2;
